import axios from 'axios'
import { cancelPreviousRequest } from '../../component/helper'
const API_URL = process.env.REACT_APP_THEME_API_URL
const MANUAL_DISPATCH_ADD = `${API_URL}/dispatch-add`
const MANUAL_DISPATCH_LIST = `${API_URL}/dispatch-list`
const MANUAL_DISPATCH_EDIT = `${API_URL}/dispatch-edit`
const MANUAL_DISPATCH_SEARCH = `${API_URL}/manual-dispatch-user`
const MANUAL_DISPATCH_BY_ID = `${API_URL}/dispatch-detail`
const DISPATCH_PICKUP_LOCATION = `${API_URL}/dispatch-pickup-location`
const DISPATCH_COURIER_ASSIGN = `${API_URL}/courier-assign`
const DISPATCH_PRINT_LABEL = `${API_URL}/print-label`
const DISPATCH_MARK_PICKUP = `${API_URL}/mark-pickup`
const DISPATCH_GET_AWB_NUMBER = `${API_URL}/get-update-awb`
const DISPATCH_UPDATE_AWB_NUMBER = `${API_URL}/update-awb-number`
const GET_DElIVERY_STATUS = `${API_URL}/get-delivery-status`
const DISPATCH_DELIVERY_STATUS = `${API_URL}/update-delivery-status`
const DISPATCH_AWB_NUMBER = `${API_URL}/universal-update-awb-number`
const ADDRESS_ADD = `${API_URL}/sku-add`
const ADDRESS_LIST = `${API_URL}/sku-list`
const ADDRESS_EDIT = `${API_URL}/sku-edit`
const ADDRESS_BY_ID = `${API_URL}/sku-detail`
const RECENT_DELIVERY = `${API_URL}/get-recently-delivery`
const RTO_DISPATCH = `${API_URL}/get-rto`
const FILTER_OPTION = `${API_URL}/get-filter-option`
const GET_DISPATCH_STATUS = `${API_URL}/get-disptach-status`
const GET_DISPATCH_ID = `${API_URL}/dispatch-by-id`
const DISPATCH_UPDATE = `${API_URL}/dispatch-update`
const DISPATCH_DOWNLOAD = `${API_URL}/dispatch-download`
const GET_DISPATCH_SAMPLE_CSV = `${API_URL}/dispatch-sample-csv`
const GET_DISPATCH_CANCLLED = `${API_URL}/disptach-cancelled`
const DISPATCH_ABORTED = `${API_URL}/dispatch-abort`
const GET_ORDER = `${API_URL}/get-user-order`
const REDEM_ADDRESS_CONFIRM = `${API_URL}/update-redem-address`
const UPDATED_DISPATCH_STATUS_BY_ORDER_ID = `${API_URL}/update-dispatch-by-orderId`
const GET_USER_ADDRESS = `${API_URL}/get-user-address`
const DISPATCH_EXCEPTION = `${API_URL}/dispatch-exception`
const DISPATCH_EXCEPTION_UPDATE = `${API_URL}/dispatch-exception-update`


export const addressAdd = (query) => {
    return axios.post(ADDRESS_ADD, query).then((d) => d.data)

}

export const addressUpdate = (query) => {
    return axios.post(ADDRESS_EDIT, query).then((d) => d.data)
}

export const addressList = (query) => {
    return axios.get(`${ADDRESS_LIST}?${query}`).then((d) => d.data)
}

export const addressById = (id) => {
    return axios.get(`${ADDRESS_BY_ID}/${id}`).then((response) => response.data?.data)
}

export const manualDispatchAdd = (query) => {
    return axios.post(MANUAL_DISPATCH_ADD, query).then((d) => d.data)

}

export const manualDispatchUpdate = (query) => {
    return axios.post(MANUAL_DISPATCH_EDIT, query).then((d) => d.data)
}

export const manualDispatchList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${MANUAL_DISPATCH_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const manualDispatchById = (id) => {
    return axios.get(`${MANUAL_DISPATCH_BY_ID}/${id}`).then((response) => response.data?.data)
}

export const dispatchHelper = (query) => {
    return axios.post(DISPATCH_PICKUP_LOCATION, query).then((d) => d.data)
}

export const manualDispatchSearch = (query) => {
    return axios.get(`${MANUAL_DISPATCH_SEARCH}?${query}`).then((d) => d.data)
}
export const dispatchCourierAssign = (query) => {
    return axios.post(DISPATCH_COURIER_ASSIGN, query).then((d) => d.data)
}
export const dispatchPrintLabel = (query) => {
    return axios.post(DISPATCH_PRINT_LABEL, query).then((d) => d.data)
}
export const dispatchMarkPickup = (query) => {
    return axios.post(DISPATCH_MARK_PICKUP, query).then((d) => d.data)
}
export const dispatchUpdateAWBNumber = (query) => {
    return axios.post(DISPATCH_UPDATE_AWB_NUMBER, query).then((d) => d.data)
}
export const dispatchGetUpdateAwbNumber = (query) => {
    return axios.get(`${DISPATCH_GET_AWB_NUMBER}?${query}`).then((d) => d.data)
}
export const getDeliveryStatus = () => {
    return axios.get(`${GET_DElIVERY_STATUS}`).then((d) => d.data)
}
export const dispatchDeliveryStatus = (query) => {
    return axios.post(DISPATCH_DELIVERY_STATUS, query).then((d) => d.data)
}
export const recentDeliveryStatus = (query) => {
    return axios.get(`${RECENT_DELIVERY}?${query}`).then((d) => d.data)
}
export const rtoDispatch = (query) => {
    return axios.get(`${RTO_DISPATCH}?${query}`).then((d) => d.data)
}
export const updateAWBNumber = (query) => {
    return axios.post(DISPATCH_AWB_NUMBER, query).then((d) => d.data)
}

export const getFilterOption = (query) => {
    return axios.get(`${FILTER_OPTION}?type=${query}`).then((d) => d.data)
}
export const getDispatchStatus = (query) => {

    return axios.get(`${GET_DISPATCH_STATUS}?upload=${query}`).then((d) => d.data)
}

export const getDispatchSampleCsv = (query) => {
    return axios.post(GET_DISPATCH_SAMPLE_CSV, query).then((d) => d.data)
}
export const getDispatchById = (query) => {
    return axios.post(GET_DISPATCH_ID, query).then((d) => d.data)
}
export const dispatchUpdate = (query) => {
    return axios.post(DISPATCH_UPDATE, query).then((d) => d.data)
}

export const dispatchDwonload = (query) => {
    return axios.get(`${DISPATCH_DOWNLOAD}?${query}`).then((d) => d.data)
}
export const dispatchCancelled = (query) => {
    return axios.post(GET_DISPATCH_CANCLLED, query).then((d) => d.data)
}
export const dispatchException = (query) => {
    return axios.post(DISPATCH_EXCEPTION, query).then((d) => d.data)
}

export const dispatchAborted = (query) => {
    return axios.post(DISPATCH_ABORTED, query).then((d) => d.data)
}

export const redemptionAddressConfirmed = (query) => {
    return axios.post(REDEM_ADDRESS_CONFIRM, query).then((d) => d.data)
}

export const updatedDispathStatusByOrderID = (query) => {
    return axios.post(UPDATED_DISPATCH_STATUS_BY_ORDER_ID, query).then((d) => d.data)
}
export const getOrder = (query) => {
    return axios.post(GET_ORDER, query).then((d) => d.data)
}

export const getUserAddressByUserId = (userId) => {
    return axios.post(GET_USER_ADDRESS, { user_code: userId }).then((d) => d.data)
}

export const dispatchExceptionUpdate = (query) => {
    return axios.post(DISPATCH_EXCEPTION_UPDATE, query).then((d) => d.data)
}


